@layer module {
.menu-container .icon {
            display: flex;
    }

.menu-container .additional:after {
            content: '';
            background-size: cover;
    }

.menu-option .icon,
:where(.menu-container).pill .icon {
            display: flex;
    }
} // layer module










@layer app {
.language-menu-wrapper.hamburger {
            margin: $size-16 0;
    }

.menu-container {
            min-width: $size-160;
    }

.menu-container .icon {
            margin: 0 $size-10 0 $size-12;
    }

.hamburger .icon {
            margin-left: 0;
    }

.hamburger .menu-container {
            min-height: $size-50;
    }

:where(.hamburger) .menu-container .icon svg {
            width: $size-28;
            height: $size-28;
            border-radius: 50%;
    }

.hamburger .menu-option {
            min-height: $size-48;
    }

.menu-container .additional:after {
            width: $size-22;
            height: $size-22;
    }

.menu-container .selected {
            width: 100%;
    }

.menu-container .arrow {
            margin: 0 $size-12 0 $size-10;
    }

.menu-container.bordered {
            border-radius: $size-10;
            height: $size-50;
    }

.menu-dropdown {
            width: $size-180;
    }

.menu-option .icon,
:where(.menu-container).pill .icon {
            margin: 0;
    }

.menu-option .icon svg,
:where(.menu-container).pill .icon svg {
            width: $size-20;
            height: $size-20;
            border-radius: 50%;
    }

.menu-container.pill {
            min-width: 0;
    }

:where(.menu-container).pill .selected {
            width: auto;
    }

:where(.menu-container).pill .arrow {
            margin: 0;
    }

.hamburger .selected,
.hamburger .menu-option {
            font-size: var(--font-size-lg);
    }

.menu-container .additional:after {
            background: url('@icons/language.svg') center no-repeat;
    }

.menu-container.bordered {
            border: 1px solid var(--header-language-menu-control-border);
    }

:where(.menu-container).pill .icon svg {
            box-shadow: var(--shadow-language-flag);
    }
} // layer app










@layer context {
      @media (max-width: 1023px) {
                :global(.auth-shell-split) .bordered {
                        background-color: var(--bg-surface);
                    }
          }
} // layer context
